module.exports = __webpack_public_path__ + "img/logo.d62fb2db.png";